//src/pages/ProfileSettings.jsx
import { useEffect, useState } from "react";
import API from "../services/api";

const ProfileSettings = () => {

  const [displayName, setDisplayName] = useState("");
  const [image, setImage] = useState(null);

  const [profileImage, setProfileImage] =
    useState("");

  const [loading, setLoading] =
    useState(false);

  // =========================
  // LOAD CURRENT PROFILE
  // =========================
  useEffect(() => {

    const loadProfile = async () => {

      try {

        const token =
          localStorage.getItem("token");

        const res = await API.get(
          "/creator-profile/me",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setDisplayName(
          res.data.display_name || ""
        );

        setProfileImage(
          res.data.profile_image || ""
        );

      } catch (err) {

        console.error(
          "Profile load failed:",
          err
        );

      }
    };

    loadProfile();

  }, []);

  // =========================
  // UPDATE PROFILE
  // =========================
  const handleSubmit = async () => {

    try {

      setLoading(true);

      const token =
        localStorage.getItem("token");

      const formData = new FormData();

      formData.append(
        "display_name",
        displayName
      );

      if (image) {
        formData.append(
          "profile_image",
          image
        );
      }

      const res = await API.post(
        "/creator-profile/profile/update",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("🔥 Profile updated!");

      setProfileImage(
        res.data.creator.profile_image
      );

      setDisplayName(
        res.data.creator.display_name
      );

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data?.detail ||
        "Update failed"
      );

    } finally {

      setLoading(false);

    }
  };

  return (

    <div className="container">

      <h2>👤 Creator Profile</h2>

      {/* PROFILE IMAGE */}

      <div
        style={{
          marginBottom: 20,
        }}
      >

        <img
          src={
            profileImage ||
            "https://via.placeholder.com/120"
          }
          alt="profile"
          style={{
            width: 120,
            height: 120,
            borderRadius: "50%",
            objectFit: "cover",
            border: "4px solid #22c55e",
          }}
        />

      </div>

      {/* DISPLAY NAME */}

      <input
        className="input"
        placeholder="Creator Name"
        value={displayName}
        onChange={(e) =>
          setDisplayName(e.target.value)
        }
      />

      {/* IMAGE */}

      <input
        type="file"
        accept="image/*"
        onChange={(e) =>
          setImage(e.target.files[0])
        }
      />

      {/* BUTTON */}

      <button
        className="button"
        onClick={handleSubmit}
        disabled={loading}
      >
        {
          loading
            ? "Saving..."
            : "Save Profile"
        }
      </button>

    </div>
  );
};

export default ProfileSettings;